export const getCombinedDrugNameAndQuantity = prescribedDrug => {
  if (!prescribedDrug) return '';

  const name = prescribedDrug.name ? prescribedDrug.name : '';
  const quantity = prescribedDrug.quantity ? ' x ' + prescribedDrug.quantity : '';
  return name + quantity;
};
